import React, { FC, useEffect, useState } from "react";

// Form components
import ContinentPicker from "./ContinentPicker";

const ContinentContainer: FC<{
  worldContinents: any;
  value: any;
  onChange: any;
}> = (props) => {
  const [continents, setContinents] = useState<string[]>(props.value);

  useEffect(() => {
    props.onChange(continents, "continents");
  }, [continents]);

  const continentChangeHandler = (
    continentValue: string,
    continentState: boolean
  ) => {
    // Add continent
    if (continentState === false) {
      if (!continents.includes(continentValue)) {
        if (continentValue === "world" && continents.length > 0) {
          setContinents([continentValue]);
        } else if (continents.length > 3) {
          setContinents(["world"]); // ! FIX THIS SHIT CODE
        } else if (continents.includes("world") && continentValue !== "world") {
          setContinents([continentValue]);
        } else {
          setContinents((previousState) => [...previousState, continentValue]);
        }
      }
      // Remove continent
    } else if (continentState === true) {
      setContinents((previousState) =>
        previousState.filter((item) => item !== continentValue)
      );
    }
  };

  return (
    <>
      {props.worldContinents.map((continent: any) => (
        <ContinentPicker
          continentLabel={continent.label}
          continentImage={continent.image}
          continentValue={continent.value}
          continentIsActive={continents.includes(continent.value)}
          continentChangeHandler={continentChangeHandler}
          key={continent.value}
        />
      ))}
    </>
  );
};

export default ContinentContainer;
